import { render, staticRenderFns } from "./SupportingDocument.vue?vue&type=template&id=486b52e8&scoped=true&"
import script from "./SupportingDocument.vue?vue&type=script&lang=js&"
export * from "./SupportingDocument.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocument.vue?vue&type=style&index=0&id=486b52e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b52e8",
  null
  
)

export default component.exports